import { startRegistration, startAuthentication, browserSupportsWebAuthn } from '@simplewebauthn/browser';

// Passkeys (WebAuthn) — thin wrapper so every caller shows the same wording.
// The server (lib/passkeys.js) produces the options and verifies the answers;
// the browser's own passkey dialog (Touch ID, Face ID, Windows Hello, a phone
// via QR, a security key) does the rest.
export const passkeysSupported = () => {
  try { return browserSupportsWebAuthn(); } catch (_) { return false; }
};

export const createPasskey = (options) => startRegistration({ optionsJSON: options });
export const assertPasskey = (options) => startAuthentication({ optionsJSON: options });

export function passkeyErrorMessage(err, action) {
  const name = err?.name || '';
  if (name === 'NotAllowedError') {
    return action === 'create'
      ? 'No passkey was created — the request was cancelled or timed out. Press the button and follow the device prompt.'
      : 'The passkey check was cancelled or timed out. Press the button and follow the device prompt.';
  }
  if (name === 'InvalidStateError') return 'This device already holds a passkey for your account. Sign in with that one, or add a passkey from another device.';
  if (name === 'NotSupportedError' || name === 'SecurityError') return 'This browser or device cannot use passkeys here. Use a current Chrome, Safari or Edge on a device with a screen lock (fingerprint, face or PIN).';
  if (name === 'AbortError') return 'The passkey request was interrupted. Please try again.';
  return err?.response?.data?.error || err?.message || 'Passkey error — please try again.';
}

// A sensible default label for a new passkey, from the device in use.
export function guessDeviceName() {
  const ua = String(navigator.userAgent || '');
  if (/iPhone/i.test(ua)) return 'iPhone';
  if (/iPad/i.test(ua)) return 'iPad';
  if (/Android/i.test(ua)) return 'Android phone';
  if (/Macintosh|Mac OS/i.test(ua)) return 'Mac';
  if (/Windows/i.test(ua)) return 'Windows PC';
  return 'This device';
}
